import React from "react";

import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Textarea,
} from "@chakra-ui/react";

import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";

export const ReativarModal = ({
  isOpen,
  onOpen,
  onClose,
  id,
  handleUpdate,
  isDesativado,
}) => {
  const schema = Yup.object().shape({});

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      ServicoAcolhimentoService.reativarSA(id, values)
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Serviço reativado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            handleUpdate();
            onClose();
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                const errors = JSON.parse(error.response.data.message);
                for (let key in errors) {
                  actions.setFieldError(key.toString(), errors[key]);
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          // if(error.response){
          //   if(error.response.data){
          //     if(error.response.data.apierror){
          //       if(error.response.data.apierror.subErrors){
          //         error.response.data.apierror.subErrors.forEach((erro) => {
          //           actions.setFieldError(
          //             erro.field,
          //             erro.message
          //           );
          //         })
          //       }
          //     } else {
          //       actions.setFieldError(
          //         error.response.data.field,
          //         error.response.data.message
          //       );
          //     }
          //   }
          // }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent p="25px" w={{ base: "100%", lg: "70%" }} bgColor="#FFF">
        <ModalHeader
          p="0px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#95BCBF"
        >
          {"Reativar serviço de acolhimento".toUpperCase()}
        </ModalHeader>
        <ModalBody p="0px" mt="25px">
          <Formik
            validationSchema={schema}
            initialValues={{
              justificativa: "",
              observacao: "",
            }}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {(props) => (
              <Form>
                <Flex flexDir="column">
                  {!isDesativado && (
                    <Field name="justificativa">
                      {({ field, form }) => (
                        <Flex flexDir="column">
                          <FormControl
                            isInvalid={
                              form.errors.justificativa &&
                              form.touched.justificativa
                            }
                          >
                            <FormLabel htmlFor="justificativa">
                              Justificativa da Reativação
                            </FormLabel>
                            <Textarea
                              {...field}
                              name="justificativa"
                              id="justificativa"
                              backgroundColor="#fff"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="Informe a Justificativa da Reativação"
                            />
                            <FormErrorMessage>
                              {form.errors.justificativa}
                            </FormErrorMessage>
                          </FormControl>
                        </Flex>
                      )}
                    </Field>
                  )}
                  {isDesativado && (
                    <Field name="observacao">
                      {({ field, form }) => (
                        <Flex flexDir="column">
                          <FormControl
                            isInvalid={
                              form.errors.observacao && form.touched.observacao
                            }
                          >
                            <FormLabel htmlFor="observacao">
                              Observações
                            </FormLabel>
                            <Textarea
                              {...field}
                              name="observacao"
                              id="observacao"
                              backgroundColor="#fff"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="Informe as observações"
                            />
                            <FormErrorMessage>
                              {form.errors.observacao}
                            </FormErrorMessage>
                          </FormControl>
                        </Flex>
                      )}
                    </Field>
                  )}

                  <Flex flexDir="row-reverse" mt="30px">
                    <Button
                      type="submit"
                      translate="no"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      isLoading={props.isSubmitting}
                    >
                      Reativar
                    </Button>
                    <Button
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      onClick={onClose}
                      mr="20px"
                    >
                      Cancelar
                    </Button>
                  </Flex>
                </Flex>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
